<template>
  <menu
    class="header__nav-menu"
    :class="{
      'is-login': $auth.loggedIn
    }"
  >
    <ul class="header__nav-menu__list">
      <li class="header__nav-menu__list__item">
        <a
          class="label header__nav-menu__list__item__link"
          exact
          data-cy="header-all-service"
          @mouseenter="changeDropdownMenuStatusHandler(true)"
          @mouseleave="changeDropdownMenuStatusHandler(false)"
        >全部服務
          <transition name="header-dropdown">
            <NavDropDownMenu
              v-show="showDropdownMenu"
              :dropdown-menu-list="allService"
              :service-is-loading="serviceIsLoading"
              @changeDropdownMenuStatusHandler="changeDropdownMenuStatusHandler"
            />
          </transition>
        </a>
      </li>
      <li
        class="header__nav-menu__list__item"
        @mouseenter="handleCategoryDropdown(applianceCleaningID, true)"
        @mouseleave="handleCategoryDropdown(applianceCleaningID, false)"
      >
        <nuxt-link
          v-if="applianceCleaningService && applianceCleaningService.subTypeList && applianceCleaningService.subTypeList.length"
          :to="{ name: 'index-id', params: { id: applianceCleaningID, toTop: true } }"
          class="label header__nav-menu__list__item__link"
          data-cy="header-appliance-cleaning"
          @click.native="logHeaderGaEvent('家電清洗')"
        >
          家電清洗
        </nuxt-link>
        <transition name="header-dropdown">
          <NavCategoryDropDownMenu
            v-show="showCategoryDropdownID === applianceCleaningID"
            :service-by-main-type="applianceCleaningService"
            :service-is-loading="serviceIsLoading"
            @changeDropdownMenuStatusHandler="handleCategoryDropdown(applianceCleaningID, $event)"
          />
        </transition>
      </li>
      <li
        class="header__nav-menu__list__item"
        @mouseenter="handleCategoryDropdown(homeCleaningID, true)"
        @mouseleave="handleCategoryDropdown(homeCleaningID, false)"
      >
        <nuxt-link
          v-if="homeCleaningService && homeCleaningService.subTypeList && homeCleaningService.subTypeList.length"
          :to="{ name: 'index-id', params: { id: homeCleaningID, toTop: true } }"
          class="label header__nav-menu__list__item__link"
          data-cy="header-appliance-cleaning"
          @click.native="logHeaderGaEvent('居家清潔')"
        >
          居家清潔
        </nuxt-link>
        <transition name="header-dropdown">
          <NavCategoryDropDownMenu
            v-show="showCategoryDropdownID === homeCleaningID"
            :service-by-main-type="homeCleaningService"
            :service-is-loading="serviceIsLoading"
            @changeDropdownMenuStatusHandler="handleCategoryDropdown(homeCleaningID, $event)"
          />
        </transition>
      </li>
      <li class="header__nav-menu__list__item">
        <a
          class="label header__nav-menu__list__item__link"
          href="https://top1.kingnet.net.tw/"
          target="_blank"
          @click="logHeaderGaEvent('今網寬頻')"
        >
          今網寬頻
        </a>
      </li>
      <li class="header__nav-menu__list__item">
        <nuxt-link
          class="label header__nav-menu__list__item__link"
          :to="{ name: 'informationStation' }"
          data-cy="header-information-station"
          @click.native="logHeaderGaEvent('生活情報站')"
        >
          生活情報站
        </nuxt-link>
      </li>
      <li class="header__nav-menu__list__item">
        <a
          class="label header__nav-menu__list__item__link"
          href="https://www.smartdaily.com.tw/household/"
          target="_blank"
          @click="logHeaderGaEvent('關於我們')"
        >
          關於我們
        </a>
      </li>
      <li class="flex-end member-setting header__nav-menu__list__item">
        <img
          v-if="showAlertIcon"
          class="alert-img"
          src="@/assets/image/edit-alert.svg"
        >
        <a
          ref="navMemberDropDownMenu"
          class="label header__nav-menu__list__item__link"
          data-cy="header-member-setting"
          @mouseenter="openMemberSettingDropdownHandler(true)"
          @mouseleave="openMemberSettingDropdownHandler(false)"
        >
          <v-badge
            :value="hasRedPoint && !showAlertIcon"
            color="pink"
            dot
            left
            offset-y="-2"
          >
            會員專區
          </v-badge>
          <transition name="header-dropdown">
            <NavMemberDropDownMenu
              v-show="showMemberDropdownMenu"
              @logout="$emit('logout')"
            />
          </transition>
        </a>
      </li>
    </ul>
  </menu>
</template>

<script>
import NavDropDownMenu from '@/components/Nav/NavDropDownMenu'
import NavMemberDropDownMenu from '@/components/Nav/NavMemberDropdownMenu'
import NavCategoryDropDownMenu from '@/components/Nav/NavCategoryDropDownMenu'
import { mapGetters } from 'vuex'
export default {
  components: {
    NavDropDownMenu,
    NavMemberDropDownMenu,
    NavCategoryDropDownMenu
  },
  props: {
    allService: {
      type: Array,
      default: () => []
    },
    serviceIsLoading: Boolean
  },
  data () {
    return {
      showDropdownMenu: false,
      showMemberDropdownMenu: false,
      showCategoryDropdownID: null,
      categoryDropdownID: {
        applianceCleaning: {
          dev: 109,
          prod: 157
        },
        homeCleaning: {
          dev: 7,
          prod: 1
        }
      },
      isDev: this.$nuxt.context.env.NODE_ENV_NAME !== 'ec' && this.$nuxt.context.env.NODE_ENV_NAME !== 'staging'
    }
  },
  computed: {
    ...mapGetters(['isGuestMember', 'hasRedPoint']),
    showAlertIcon () {
      return this.isGuestMember || (this.$auth.loggedIn && this.$auth.user && !this.$auth.user.IsServiceAccountTransferEnd)
    },
    applianceCleaningID () {
      const { dev, prod } = this.categoryDropdownID.applianceCleaning
      return this.isDev ? dev : prod
    },
    homeCleaningID () {
      const { dev, prod } = this.categoryDropdownID.homeCleaning
      return this.isDev ? dev : prod
    },
    applianceCleaningService () {
      return this.getServiceByMainType(this.applianceCleaningID)
    },
    homeCleaningService () {
      return this.getServiceByMainType(this.homeCleaningID)
    }
  },
  watch: {
    showMemberDropdownMenu (val) {
      if (val) {
        document.querySelector('body').addEventListener('click', this.clickOutsideHandler)
      } else {
        document.querySelector('body').removeEventListener('click', this.clickOutsideHandler)
      }
    }
  },
  methods: {
    changeDropdownMenuStatusHandler (status) {
      this.showDropdownMenu = status
      if (status) this.logHeaderGaEvent('全部服務')
    },
    openMemberSettingDropdownHandler (status) {
      this.showMemberDropdownMenu = status
    },
    logHeaderGaEvent (headerName) {
      this.$gaLogEvent('導覽列', `header_${headerName}`)
    },
    clickOutsideHandler (e) {
      if (this.isMobile) {
        this.menuMobileIsOpen = false
      } else {
        const dropdownMenu = this.$refs.navMemberDropDownMenu
        const clickDropdownMenu = dropdownMenu === e.target || dropdownMenu.contains(e.target)
        if (!clickDropdownMenu && this.showMemberDropdownMenu) {
          this.showMemberDropdownMenu = false
        }
      }
    },
    handleCategoryDropdown (id, status) {
      this.showCategoryDropdownID = status ? id : null
      if (status) {
        const service = this.getServiceByMainType(id)
        if (service && service.mainTypeName) {
          this.logHeaderGaEvent(service.mainTypeName)
        }
      }
    },
    getServiceByMainType (id) {
      return this.allService.find(item => item.typeParent === id) || {}
    }
  }
}
</script>

<style lang="scss">
.header__nav-menu {
  height: $headerHeight;
  &__list {
    list-style: none;
    display: flex;
    vertical-align: baseline;
    font-size: 0;
    width: 100%;
    &__item {
      position: relative;
      display: inline-block;
      &__link {
        display: inline-flex;
        align-items: center;
        height: $headerHeight;
        padding-inline: 16px;
        box-sizing: border-box;
        font-size: pxTorem(17px);
        line-height: pxTorem(24px);
        font-weight: bold;
        text-decoration: none;
        transition: background-color .3s, color .3s;
        user-select: none;
        color: $color-text-primary;
        text-decoration: none;
        word-break: keep-all;
        .v-badge {
          display: inline-flex;
          align-items: center;
        }
        .arrow {
          margin-left: 5px;
          display: inline-block;
          transition: transform .5s;
          font-size: pxTorem(20px);
          &.is-open {
            transform: rotate(180deg);
          }
        }
      }
      &.flex-end {
        margin-left: auto;
      }
      &.member-setting {
        position: relative;
        .alert-img {
          position: absolute;
          top: 15px;
          left: 0px;
        }
      }
    }
  }
}
.header-dropdown-leave-active,
.header-dropdown-enter-active {
  transition: all 0.3s ease;
  transform: translate(0, 8px);
}
.header-dropdown-enter-to,
.header-dropdown-leave-from {
  transform: translate(0, 0px);
  opacity: 1;
  visibility: visible;
}
.header-dropdown-leave-to {
  opacity: 0;
  visibility: hidden;
}
@media (max-width: 1024px) {
  .header__nav-menu .header__nav-menu {
    &__list {
      padding-left: 0;
      &__item {
        &__link {
          padding-inline: 12px;
        }
      }
    }
  }
}
@media (max-width: 880px) {
  .header__nav-menu .header__nav-menu {
    &__list {
      &__item {
        &__link {
          padding-inline: 10px;
        }
      }
    }
  }
}
/** 手機 */
@media screen and (max-width: $mobileWidth) {
  .header__nav-menu {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.header__nav-menu__list__item__link {
  color: $color-text-primary;
  &:hover, &.is-open {
    color: $color-primary;
  }
}
</style>
